export enum DeliveryType {
  UNASSIGNED = 'UNASSIGNED',
  PICKUP = 'PICKUP',
  DELIVER = 'DELIVER',
}

export enum CartOperationType {
  ADD = 'ADD',
  UPDATE = 'UPDATE',
  REMOVE = 'REMOVE',
}

export type AddCartItem = {
  equipmentId: string | number;
  name: string;
  imageSource: string;
  slug: string;
  quantity: number;
};

export type CartItem = {
  equipmentId: string | number;
  categoryName?: string;
  categoryId?: string | number;
  categoryIdHierarchy?: [string];
  categoryNameHierarchy?: [string];
  name: string;
  imageSource: string;
  slug: string;
  quantity: number;
  startDate: number;
  endDate: number;
  isStartDateValid?: boolean;
};

export type CartModalConfigType = {
  cartOperationType: CartOperationType;
  equipmentId: string | number;
  equipmentClassName: string;
  imageSource?: string;
  slug: string;
  index?: number;
  quantity?: number;
  deliveryType?: DeliveryType;
  startDate?: number;
  endDate?: number;
  open: boolean;
  toggleCartHeaderOnUpdate: boolean;
};

export type CartHeaderConfig = {
  open: boolean;
  index?: number;
  maxItemsToShow?: number;
};

export type CartItemResponse = {
  delivery_date: number;
  return_date: number;
  equipment_class_id: string | number;
  equipment_img_url: string;
  equipment_name: string;
  quantity: number;
  slug: string;
};

export type CartResponse = {
  cart_details: CartItemResponse[];
  job_site: string | null;
  user_type: string | null;
  user_uuid: string | null;
};

export type UpdateCartResponse = {
  cart_details: CartItemResponse[];
  job_site: string | null;
  user_type: string | null;
  user_uuid: string | null;
};

export type UpdateCartRequest = {
  cart_details: CartItemResponse[];
  job_site?: string;
  user_timezone?: string;
};

export enum CartBackendSyncStatus {
  IS_LOADING = 'IS_LOADING',
  ERROR = 'ERROR',
}

export type IsTaxExemptRequestParams =
  | { stateAbbreviation: string; jobsiteId?: undefined }
  | { stateAbbreviation?: undefined; jobsiteId: number };

export type IsTaxExemptResponse = {
  company_id: number;
  jobsite_id: number;
  is_tax_exempt: boolean;
};
